import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForceXNudgeSymbol} from "../reels/BruteForceXNudgeSymbol";
import {BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceStickyXNudgePresentation implements SimplePresentation {
    name: string = "StickyXNPresentation";
    private _tl: gsap.core.Timeline;

    shouldRun(): boolean {
        return BruteForce.model.gameData.mode === BruteForceGameMode.FREESPIN_SUPER && BruteForce.model.gameData.nextMode === BruteForceGameMode.FREESPIN_SUPER;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = gsap.timeline();
        this._tl.add(() => controller.setSkipCallback(() => {
            this._tl.timeScale(1.5);
        }));

        BruteForce.model.toNudge.forEach((value: boolean, reelId: number) => {
            if (value) {
                BruteForce.betlineView.hideLinesAndAmount();
                const xNudgeSym: BruteForceXNudgeSymbol = <BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelId].getStopSymbolAt(0),
                    nudgeTl: gsap.core.Timeline = gsap.timeline(),
                    xnudgeReel: SimpleReelModel = BruteForce.allreelsView.reelModels[reelId];
                if (BruteForce.model.gameData.xNudgeSticky[reelId]) {
                    nudgeTl.add(()=>{BruteForceSound.playNudgeStickySuccess(xNudgeSym.symbolName)},0);
                    nudgeTl.add(xNudgeSym.setState(BruteForceSymbolStates.HAPPY),0);
                    const lockTl:gsap.core.Timeline=gsap.timeline();
                    lockTl.to(this,{duration:1});
                    lockTl.add(xNudgeSym.addLockAnimation());
                    nudgeTl.add(lockTl,0);
                } else {
                    nudgeTl.add(()=>{BruteForceSound.playNudgeStickyFail(xNudgeSym.symbolName)},0);
                    nudgeTl.add(xNudgeSym.setState(BruteForceSymbolStates.SAD),0);
                }
                this._tl.add(nudgeTl, 0.1);
            }

        });
        this._tl.add(() => {
            BruteForceSound.resetNudgeStickySound();
            controller.setSkipCallback();
            controller.finish();
        });

    }
}